import { useEffect, useState } from 'react';
import { parseMoney } from '../utils/format';

interface Props {
  value: number;
  onChange: (n: number) => void;
  placeholder?: string;
  prefix?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  'aria-label'?: string;
}

export function MoneyInput({ value, onChange, placeholder, prefix = '$', autoFocus, disabled, ...rest }: Props) {
  const [text, setText] = useState(formatInput(value));

  useEffect(() => {
    // Only overwrite when the external value differs from our parsed text
    if (parseMoney(text) !== value) setText(formatInput(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="relative">
      {prefix && (
        <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-ink-400 dark:text-ink-300">
          {prefix}
        </span>
      )}
      <input
        type="text"
        inputMode="decimal"
        className={`input ${prefix ? 'pl-7' : ''} text-right font-mono tabular-nums`}
        value={text}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={disabled}
        onChange={e => {
          const v = e.target.value;
          setText(v);
          onChange(parseMoney(v));
        }}
        onBlur={() => setText(formatInput(parseMoney(text)))}
        aria-label={rest['aria-label']}
      />
    </div>
  );
}

function formatInput(n: number): string {
  if (n === 0) return '';
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}
